export const PLAN_LOCK_DATE = "2026-09-22";

const MILLISECONDS_PER_DAY = 86400000;

export function daysUntilLock() {
  return Math.ceil((new Date(PLAN_LOCK_DATE) - new Date()) / MILLISECONDS_PER_DAY);
}
